import { ReactElement } from 'react';
import {
  SheetsViewerV2ContextProvider,
  SheetViewerV2ContextMenuProvider,
} from 'src/components/viewers/SheetsViewerV2/SheetsViewerV2.context';

type Props = {
  projectId: string;
  shouldHideViewer: boolean;
  children: ReactElement;
};

export function SheetsViewerV2({
  projectId,
  shouldHideViewer,
  children,
}: Props) {
  return (
    <SheetViewerV2ContextMenuProvider>
      <SheetsViewerV2ContextProvider
        projectId={projectId}
        shouldHideViewer={shouldHideViewer}
      >
        {children}
      </SheetsViewerV2ContextProvider>
    </SheetViewerV2ContextMenuProvider>
  );
}
